import { render, staticRenderFns } from "./typeTransportCell.vue?vue&type=template&id=4f0b69c4&"
import script from "./typeTransportCell.vue?vue&type=script&lang=js&"
export * from "./typeTransportCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports